import { RKPI_SPEED_OPTIONS } from '../Froala';
import { RichTextRkpi, RichTextRkpiSpeed } from '../types';

export const getRkpiDataFromAttrs = (el: Element): RichTextRkpi => {
  let to = Number(el.getAttribute('data-rkpi-number-to'));
  let from = Number(el.getAttribute('data-rkpi-number-from'));
  const prefix = el.getAttribute('data-rkpi-prefix') ?? '';
  const suffix = el.getAttribute('data-rkpi-suffix') ?? '';
  let dataSpeed = el.getAttribute('data-rkpi-speed');
  let speed: RichTextRkpiSpeed = 'medium';

  if (isNaN(to)) to = 100;
  if (isNaN(from)) from = 100;

  if (isNaN(from)) from = 0;
  if (isNaN(to)) to = 100;
  if (dataSpeed) {
    if (Object.hasOwn(RKPI_SPEED_OPTIONS, dataSpeed)) speed = dataSpeed as RichTextRkpiSpeed;
    else {
      const parsedSpeed = parseFloat(dataSpeed);
      if (!isNaN(parsedSpeed)) {
        for (const key in RKPI_SPEED_OPTIONS) {
          const val = RKPI_SPEED_OPTIONS[key as RichTextRkpiSpeed];
          if (val.duration === parsedSpeed) {
            speed = key as RichTextRkpiSpeed;
            break;
          }
        }
      }
    }
  }

  return { to: to as number, from: from as number, prefix, suffix, speed };
};

export const getRkpiDurationFromSpeed = (speed: RichTextRkpiSpeed): number => {
  if (!Object.hasOwn(RKPI_SPEED_OPTIONS, speed)) return RKPI_SPEED_OPTIONS.medium.duration;
  return RKPI_SPEED_OPTIONS[speed].duration;
};

export const animateRkpi = (
  element: Element,
  start: number,
  end: number,
  duration: number,
  prefix: string | null = null,
  suffix: string | null = null,
) => {
  let startTimestamp: number | null = null;
  const step = (timestamp: number) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    element.innerHTML = Math.floor(progress * (end - start) + start).toString();
    if (prefix) element.innerHTML = prefix + element.innerHTML;
    if (suffix) element.innerHTML = element.innerHTML + suffix;
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};

export const rkpiElementV3ToV4 = (el: HTMLElement) => {
  el.removeAttribute('class');
  const { to, from, prefix, suffix, speed } = getRkpiDataFromAttrs(el);

  el.setAttribute('data-rkpi-active', 'false');
  el.setAttribute('data-rkpi-number-to', to.toString());
  el.setAttribute('data-rkpi-number-from', from.toString());
  el.setAttribute('data-rkpi-prefix', prefix);
  el.setAttribute('data-rkpi-suffix', suffix);
  el.setAttribute('data-rkpi-speed', speed.toString());

  el.removeAttribute('data-from');
  el.removeAttribute('data-to');
  el.removeAttribute('data-speed');
  el.removeAttribute('data-prefix');
  el.removeAttribute('data-suffix');
  el.removeAttribute('data-decimal');

};
